
/* INT: Apparel gallery — sync .is-activated thumbnails on Flickity swipe/arrow nav v1
   Framed print has its own hookFlickity in product-framedprint.liquid.
   This block is Liquid-gated so it never runs on framed print pages. */
/* Track thumbnail pointerdown so select patch knows to be instant */
document.addEventListener('pointerdown', function (e) {
  if (e.target && e.target.closest && e.target.closest('[data-slideshow-thumbnail]')) {
    window.__intThumbClickPending = true;
    setTimeout(function () { window.__intThumbClickPending = false; }, 400);
  }
}, { capture: true, passive: true });

(function () {
  'use strict';
  function _intApparelThumbSync() {
    var ss = document.querySelector('[data-product-slideshow]');
    var _Flk = window.Flickity || (window.themeVendor && window.themeVendor.Flickity);
    if (!ss || !_Flk || !_Flk.data) return;
    var flkty = _Flk.data(ss);
    if (!flkty || flkty._intApparelThumbSynced) return;
    flkty._intApparelThumbSynced = true;
    _intApparelThumbSync._done = true;
    /* Force instant navigation + guard against out-of-bounds selects.
       Pipeline's Media.doImageChange (theme.js line 6934) calls
       flkty.cells.findIndex(matchesMedia) to locate the new variant's
       hero, then passes the result directly to flkty.select. When VIA
       hasn't yet rebuilt cells for the new variant, findIndex returns -1
       and Flickity clamps that to index 0 — producing the "first image
       of the current color flashes" symptom on swatch click. Ignoring
       these out-of-bounds calls is safe: VIA will rebuild cells in the
       next ~50-200ms and navigate correctly to the new variant's hero. */
    if (!flkty._intSelectPatched) {
      flkty._intSelectPatched = true;
      var _origSel = flkty.select.bind(flkty);
      flkty.select = function (index, isWrapped, isInstant) {
        isInstant = true;
        if (typeof index === 'number' && (index < 0 || index >= flkty.cells.length)) {
          return; /* target not in current cells — VIA will handle it */
        }
        return _origSel(index, isWrapped, isInstant);
      };
    }
    /* ── INT: Adaptive VP height v1 ───────────────────────────────────
       Sets viewport height from the selected image's natural aspect
       ratio.  Replaces _propagateCellHeight (which locked ALL cells to
       cell[0]'s height) and the resize()-based _onLoad (which could
       not escape the inline-height lock and triggered 100+ re-entries).
    ─────────────────────────────────────────────────────────────────── */
    /* INT: cache modal product-photo AR — computed once per slideshow.
       Reads data-aspect-ratio from all slides, finds the mode (most
       common AR rounded to 2 decimals). Size chart and mismatched
       variant heroes letterbox inside this capped container. */
    function _intGetContainerAR(_ss) {
      if (_ss._intCachedAR) return _ss._intCachedAR;
      var slides = _ss.querySelectorAll('[data-media-slide]');
      if (!slides.length) return 0;
      var counts = {};
      var maxCount = 0, modeAR = 0;
      for (var i = 0; i < slides.length; i++) {
        var ar = parseFloat(slides[i].dataset.aspectRatio);
        if (!ar || ar <= 0) continue;
        var key = ar.toFixed(2);
        counts[key] = (counts[key] || 0) + 1;
        if (counts[key] > maxCount) { maxCount = counts[key]; modeAR = ar; }
      }
      /* Fallback to slide[0] if no consensus (single-slide edge case) */
      if (!modeAR && slides[0]) modeAR = parseFloat(slides[0].dataset.aspectRatio) || 0;
      _ss._intCachedAR = modeAR;
      return modeAR;
    }

    function _intSetVPHeight() {
      var _ss2 = document.querySelector('[data-product-slideshow]');
      if (!_ss2) return;
      var _vp2 = _ss2.querySelector('.flickity-viewport');
      var _sel2 = _ss2.querySelector('[data-media-slide].is-selected');
      if (!_vp2 || !_sel2) return;
      var _img2 = _sel2.querySelector('img');
      if (!_img2 || !_img2.naturalWidth || !_img2.naturalHeight) return;
      var _vpW = _vp2.offsetWidth;
      if (_vpW < 50) return;
      var _neededH = Math.round(_vpW * (_img2.naturalHeight / _img2.naturalWidth));
      /* INT: Cap container to the dominant product-photo AR so portrait
         slides (size chart) and variant heroes with odd crops letterbox
         via object-fit:contain instead of expanding the container. */
      var _containerAR = _intGetContainerAR(_ss2);
      if (_containerAR > 0 && window.innerWidth < 768) {
        /* Lock container height to the dominant product-photo AR so all
           slides letterbox to the same envelope. Without this cap, a
           portrait slide (size chart, model shot with unusual natural
           dimensions) makes the container tall and the swatches/thumbs
           below shift — causing the mobile mis-tap problem where a fast
           swatch press lands on a moving target. */
        _neededH = Math.min(_neededH, Math.round(_vpW / _containerAR));
      }
      /* Set cell, VP, and container to the correct height */
      _sel2.style.height = _neededH + 'px';
      _vp2.style.height  = _neededH + 'px';
      _ss2.style.height    = _neededH + 'px';
      _ss2.style.minHeight = _neededH + 'px';
      /* Update Flickity internal cache so setGallerySize won't snap back */
      var _f2 = _Flk && _Flk.data && _Flk.data(_ss2);
      if (_f2 && _f2.cells && _f2.cells[_f2.selectedIndex]) {
        var _c = _f2.cells[_f2.selectedIndex];
        if (_c.size) {
          _c.size.height = _neededH;
          _c.size.outerHeight = _neededH;
          _c.size.innerHeight = _neededH;
        }
        _f2.maxCellHeight = _neededH;
      }
      /* Desktop: do NOT sync thumb holder to vp — CSS controls thumb strip height */
      /* Mobile: clear padding that fights with height */
      if (window.innerWidth < 768) { _ss2.style.paddingTop = '0'; }
    }
    /* Expose for other scripts */
    window.__intSetVPHeight = _intSetVPHeight;
    window.__intGetContainerAR = _intGetContainerAR;

    /* Clear stale inline heights + crush 600px baseline cells at init.
       Flickity measures unloaded cells at ~600px (unconstrained DOM height).
       These cause a sub-frame VP=600px flash when navigating through them.
       Set them to cell[0]'s correct height so adaptiveHeight stays stable. */
    if (flkty.cells) {
      var _initH = null;
      var _c0 = flkty.cells[0];
      if (_c0 && _c0.size && _c0.size.height > 20 && _c0.size.height < 590) {
        _initH = _c0.size.height;
      }
      flkty.cells.forEach(function(c) {
        if (c.element) c.element.style.height = '';
        if (_initH && c.size && c.size.height >= 590) {
          c.size.height = _initH;
          c.size.outerHeight = _initH;
          c.size.innerHeight = _initH;
          c.element.style.height = _initH + 'px';
        }
      });
    }
    /* INT v21: Set initial VP height from first slide. If img hasn't
       loaded yet (naturalWidth=0), poll until it has dimensions so we
       can apply the container-AR cap at init. Prevents the 4px collapse
       that occurs on first user interaction when vp starts at a natural
       AR (0.988 → 362px) then snaps to capped AR (1.0 → 358px). */
    (function _intInitialSetVPHeight() {
      var _ssInit = document.querySelector('[data-product-slideshow]');
      var _selInit = _ssInit && _ssInit.querySelector('[data-media-slide].is-selected');
      var _imgInit = _selInit && _selInit.querySelector('img');
      if (_imgInit && _imgInit.naturalWidth && _imgInit.naturalHeight) {
        _intSetVPHeight();
      } else if (_imgInit) {
        _imgInit.addEventListener('load', _intSetVPHeight, { once: true });
        _imgInit.addEventListener('error', _intSetVPHeight, { once: true });
        /* Also poll in case load event already fired before listener attached */
        var _pollCount = 0;
        var _pollInit = setInterval(function() {
          _pollCount++;
          if (_imgInit.naturalWidth && _imgInit.naturalHeight) {
            clearInterval(_pollInit);
            _intSetVPHeight();
          } else if (_pollCount > 20) {
            clearInterval(_pollInit);
          }
        }, 50);
      }
    })();

    flkty.on('select', function () {
      var freshSS = document.querySelector('[data-product-slideshow]');
      var sel = freshSS && freshSS.querySelector('[data-media-slide].is-selected');
      if (!sel) return;

      /* Guard: skip re-entrant select calls for the same MEDIA. Flickity +
         wrapAround + resize can cascade 100+ select events for a single
         user click — only process the first one. INT 2026-07c: the guard
         was index-based, but on a colour change the new hero usually lands
         on the SAME index (0) in the rebuilt cell list, so the handler
         bailed and never recalculated the viewport height for the new
         hero — if it was taller than the old colour's slide it rendered
         bottom-cropped until the next thumb click. Keying the guard to the
         media-id processes the new hero while still swallowing the
         same-image select cascade. */
      var mediaId = sel.dataset.mediaId;
      if (mediaId === flkty._intLastHandledMedia) return;
      flkty._intLastHandledMedia = mediaId;

      /* Thumbnail .is-activated sync */
      document.querySelectorAll('[data-slideshow-thumbnail]').forEach(function (t) {
        t.classList.toggle('is-activated', t.dataset.mediaSelect === mediaId);
      });

      /* Set VP height from selected image's natural dimensions.
         No flkty.resize() — that re-reads locked cell heights and loops. */
      var _img = sel.querySelector('img');
      if (_img && _img.complete && _img.naturalHeight > 0) {
        _intSetVPHeight();
      } else if (_img) {
        _img.addEventListener('load', function() { _intSetVPHeight(); }, { once: true });
        _img.addEventListener('error', function() { _intSetVPHeight(); }, { once: true });
      }
    });
  }
  /* Hook after VIA settle (normal swatch-change flow) */
  document.addEventListener('int:gallery:settled', _intApparelThumbSync);
  /* Poll until Flickity exists — fixed timeouts fail when domInteractive > 3s */
  (function _pollApparel() {
    if (_intApparelThumbSync._done) return;
    var ss = document.querySelector('[data-product-slideshow]');
    var _Flk = window.Flickity || (window.themeVendor && window.themeVendor.Flickity);
    if (ss && _Flk && _Flk.data && _Flk.data(ss)) {
      _intApparelThumbSync();
      return;
    }
    if (Date.now() - (_pollApparel._start || (_pollApparel._start = Date.now())) < 20000) {
      setTimeout(_pollApparel, 500);
    }
  })();

  /* Prefetch adjacent slides so images are in cache before user swipes.
     Walks outward from the selected index, decoding 2 slides ahead and 1 behind.
     Uses img.decode() which is non-blocking and respects browser connection limits. */
  function _prefetchAdjacentSlides(ss, selectedIndex) {
    if (!ss) return;
    var slides = Array.from(ss.querySelectorAll('[data-media-slide]'));
    if (!slides.length) return;
    /* 🚨 INT 2026-08-30: THE SELECTED SLIDE GETS THE ROAD TO ITSELF.
       Nils, testing the fixed draft on his iPhone: "pressing the color swatches
       is making the images change slower... the new colour taking a long time to
       appear." Every synthetic measurement said the opposite — fewer bytes,
       faster paint, on a throttled pipe and a throttled CPU — so I logged the
       ORDER the browser asks for things after a click:

         MAIN   +713ms  449KB w=932  <- the slide on stage
                +1505ms 1487KB w=2000   neighbour
                +1715ms 2183KB w=2000   neighbour
         draft  +649ms  449KB w=932  <- the slide on stage
                +860ms  390KB w=932     neighbour
                +950ms  414KB w=932     neighbour
                +1031ms 571KB w=932     neighbour

       Once the srcset fix let the neighbours negotiate properly they stopped
       being slow enough to stay out of the way. All three now start within
       ~380ms of the one the visitor is actually looking at, and on a phone with
       a handful of parallel connections they take bandwidth off it. Total bytes
       went DOWN and the wait went UP — which is exactly the report.

       So the selected slide is restored on its own, and the three neighbours
       wait for it to finish. A rig with one FIFO pipe cannot show this; only
       the request order can. The 1500ms fallback means a slow or failed hero
       can never strand the prefetch. */
    function _restore(offset) {
      var target = slides[selectedIndex + offset];
      if (!target) return;
      var img = target.querySelector('img');
      if (!img) return;
      /* Restore src if iOS OOM guard blanked it — use getAttribute to get
         the literal attribute value, not the resolved URL (src="" resolves
         to the page URL which is truthy, defeating the !img.src check).
         Skip if already restored to avoid browser resetting complete=false. */
      var _rawSrc = img.getAttribute('src') || '';
      var _isBlanked = !_rawSrc || _rawSrc.length < 10;
      /* INT 2026-08-28: restore the srcset too, and BEFORE the src.
         The iOS OOM guard in layout/theme.liquid blanks src AND srcset on
         off-screen slides, saving both to data-int-src / data-int-srcset.
         This function only ever put the src back, so a slide revealed by a
         colour swatch came back carrying the un-negotiated fallback src,
         which Liquid renders at width=2000. Measured on an iPhone: every
         gallery slide ended at naturalWidth 2000 inside a 378px box, about
         4.6x the pixels needed, and 353 KB per swatch click against 199 KB
         where the srcset survives. Restoring srcset first lets the browser
         pick the right candidate for the src write below. The inequality
         test keeps same-value writes out, so nothing resets complete=false
         needlessly. Scope is unchanged: only the 4 slides this prefetch
         already touches. */
      if (img.dataset.intSrcset && img.getAttribute('srcset') !== img.dataset.intSrcset) {
        img.setAttribute('srcset', img.dataset.intSrcset);
      }
      /* INT 2026-08-30: the same restore for the framed print path.
         sections/product-framedprint.liquid renders BOTH int-gallery-swatches and
         int-variant-gallery-framed, so this prefetch runs on framed print pages too,
         but there the images are written by snippets/media-framedprint.liquid, which
         emits data-fp-srcset, not data-int-srcset. The fp branch below restored src
         with no srcset, which is the same width=2000 fallback the intSrcset restore
         above was written to stop. fpSrcset is only ever written by the two
         framedprint files, so nothing outside that template is touched. */
      if (img.dataset.fpSrcset && img.getAttribute('srcset') !== img.dataset.fpSrcset) {
        img.setAttribute('srcset', img.dataset.fpSrcset);
      }
      if (_isBlanked && img.dataset.intSrc) { img.src = img.dataset.intSrc; }
      else if (_isBlanked && img.dataset.fpSrc) { img.src = img.dataset.fpSrc; }
      /* Kick decode — downloads and decodes without blocking the main thread */
      img.loading = 'eager';
      if (img.src && typeof img.decode === 'function') {
        img.decode().catch(function () {});
      }
    }
    _restore(0);
    var _selSlide = slides[selectedIndex];
    var _selImg = _selSlide ? _selSlide.querySelector('img') : null;
    var _rest = function () { [1, 2, -1].forEach(_restore); };
    if (!_selImg) { _rest(); return; }
    if (_selImg.complete && _selImg.naturalWidth > 0) { _rest(); return; }
    var _fired = false;
    var _go = function () { if (_fired) return; _fired = true; _rest(); };
    _selImg.addEventListener('load', _go, { once: true });
    _selImg.addEventListener('error', _go, { once: true });
    setTimeout(_go, 1500);
  }

  /* Warm up slides 1 and 2 immediately after settle */
  function _warmGallery() {
    var ss = document.querySelector('[data-product-slideshow]');
    var _Flk = window.Flickity || (window.themeVendor && window.themeVendor.Flickity);
    var flkty = _Flk && ss && _Flk.data(ss);
    if (!flkty) return;
    /* INT: Skip prefetch unless Flickity is actually on the variant
       hero. v2 of this guard only checked that flkty existed, but on
       fast inits Flickity exists at the 1500ms timer with its default
       selectedIndex=0 even though VIA has not yet navigated to the
       variant hero (e.g. idx 5 for royal-blue). Prefetching from
       index 0 promotes slides 0, 1, 2 to eager, which then compete
       with the real LCP slide for bandwidth. Cross-check
       selectedIndex against window.__intVariantHeroMap before
       proceeding. Falls back to legacy behaviour when the map is
       absent or the variant has no featured_media. */
    var map = window.__intVariantHeroMap;
    if (map) {
      var urlVid = new URLSearchParams(location.search).get('variant');
      var vid = urlVid || window.__intDefaultVariantId;
      if (vid && map[String(vid)]) {
        var expectedHeroId = String(map[String(vid)]);
        var selCell = flkty.cells && flkty.cells[flkty.selectedIndex];
        var currentHeroId = selCell && selCell.element && selCell.element.dataset
          ? String(selCell.element.dataset.mediaId)
          : null;
        if (currentHeroId !== expectedHeroId) return;
      }
    }
    _prefetchAdjacentSlides(ss, flkty.selectedIndex);
    /* Prefetch on every slide change — fires before the user sees the next slide */
    if (!flkty._intApparelPrefetch) {
      flkty._intApparelPrefetch = true;
      flkty.on('select', function () {
        var freshSS = document.querySelector('[data-product-slideshow]');
        var freshFlk = window.Flickity || (window.themeVendor && window.themeVendor.Flickity);
        var f = freshFlk && freshSS && freshFlk.data(freshSS);
        if (f) _prefetchAdjacentSlides(freshSS, f.selectedIndex);
      });
    }
  }
  document.addEventListener('int:gallery:settled', _warmGallery);
  [1500, 3000].forEach(function (ms) { setTimeout(_warmGallery, ms); });
})();
